/* GB port 29 Oct 2026 — $250 catalogue-minimum checkout guard for Prestige (ported from the Craft theme's assets/gb-moq.js).
   Rules live in Liquid (snippets/gb-min-state). sections/cart-drawer and sections/main-cart render the checkout button
   disabled and print the message while the cart is locked; Prestige re-renders both sections after every AJAX cart change.
   This script is the safety net on every page:
   - reads the state marker ([data-gb-min-state]) and refreshes it after every cart change through the Section Rendering API
     (/cart?sections=gb-min-state), listening to Prestige's cart events (cart:change / cart:refresh) plus a DOM observer;
   - while locked: disables every button[name="checkout"], shows the message above it, hides dynamic / express checkout
     buttons (html.gb-moq-locked), and stops direct /checkout links and checkout form submits (sends the buyer to the cart). */
(function () {
  if (window.__gbMoq) return;
  window.__gbMoq = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART = ROOT + 'cart';
  var ATTRS = ['data-locked', 'data-cat', 'data-n', 'data-msg'];
  var state = { locked: false, html: '' };
  var mute = false, timer;

  var css = document.createElement('style');
  css.textContent =
    '.gb-moq-note{font-size:.875rem;line-height:1.6;color:#1F1B16;border:1px solid #E3D8C4;background:#FBF7EF;padding:.75rem 1rem;margin:0 0 .75rem;text-align:start;}' +
    '.gb-moq-note a{color:#16424A;text-decoration:underline;}' +
    '.gb-moq-locked .additional-checkout-buttons,.gb-moq-locked .shopify-payment-button,' +
    '.gb-moq-locked [data-shopify="dynamic-checkout-cart"],.gb-moq-locked shopify-accelerated-checkout-cart,' +
    '.gb-moq-locked shopify-accelerated-checkout{display:none !important;}';
  document.head.appendChild(css);

  function marker() {
    return document.querySelector('cart-drawer [data-gb-min-state]') ||
      document.querySelector('.cart-page [data-gb-min-state]') ||
      document.querySelector('[data-gb-min-state]');
  }

  function fromMarker(m) {
    if (!m) return false;
    state.locked = m.getAttribute('data-locked') === '1';
    state.html = state.locked ? (m.getAttribute('data-msg') || '') : '';
    return true;
  }

  function apply() {
    mute = true;
    document.documentElement.classList.toggle('gb-moq-locked', state.locked);
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      var host = b.parentNode;
      var note = host && host.querySelector(':scope > [data-gb-moq-note]');
      if (!note && host && host.parentNode) note = host.parentNode.querySelector('[data-gb-moq-note]');
      if (state.locked) {
        if (!b.disabled) b.disabled = true;
        b.setAttribute('data-gb-moq', '1');
        if (!note && host) {
          note = document.createElement('div');
          note.className = 'gb-moq-note';
          note.setAttribute('data-gb-moq-note', '');
          note.setAttribute('role', 'status');
          host.insertBefore(note, b);
        }
        if (note && note.innerHTML !== state.html) note.innerHTML = state.html;
      } else {
        /* Only the lock disables checkout buttons (Liquid in cart-drawer / main-cart, or this script) */
        if (b.getAttribute('data-gb-moq')) { b.disabled = false; b.removeAttribute('data-gb-moq'); }
        if (note && note.parentNode) note.parentNode.removeChild(note);
      }
    });
    setTimeout(function () { mute = false; }, 0);
  }

  function fromSection(html) {
    var m = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gb-min-state]');
    if (!m) return false;
    document.querySelectorAll('[data-gb-min-state]').forEach(function (el) {
      ATTRS.forEach(function (a) { el.setAttribute(a, m.getAttribute(a) || ''); });
    });
    fromMarker(m);
    apply();
    return true;
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(CART + '?sections=gb-min-state', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('gb-min-state ' + r.status); return r.json(); })
        .then(function (j) { if (j && j['gb-min-state']) fromSection(j['gb-min-state']); })
        .catch(function () {});
    }, 250);
  }

  /* Block checkout while locked */
  document.addEventListener('submit', function (e) {
    if (!state.locked) return;
    var s = e.submitter;
    if (s && s.name === 'checkout') {
      e.preventDefault();
      if (!document.querySelector('.cart-page')) window.location.href = CART;
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (!state.locked) return;
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(https?:\/\/[^\/]+)?(\/[a-z]{2}(-[a-z]{2})?)?\/checkout(\/|\?|$)/i.test(href)) {
      e.preventDefault();
      window.location.href = CART;
    }
  }, true);

  /* Prestige cart events */
  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  /* Prestige re-renders the drawer / cart page content: re-read the fresh Liquid marker */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (mute) return;
      if (fromMarker(marker())) apply();
    });
    function watch() {
      ['cart-drawer', '.shopify-section--main-cart'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.__gbWatched) { el.__gbWatched = true; mo.observe(el, { childList: true, subtree: true }); }
        });
      });
    }
    watch();
    document.addEventListener('DOMContentLoaded', watch);
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function init() { fromMarker(marker()); apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
